import emojiRegex from "emoji-regex";

declare global {
  interface String {
      /**
       * Important: Ensure the emoji-regex package is updated to the latest major version
       */
      doAnyEmojisExist(): boolean;

      /**
       * Transforms a URL encoded string to its correct text representation
       */
      formatVerificationCodeFromUrl(): string;
  }    
}

/**
* Ensure the emoji-regex package is updated to the latest major version
*/
String.prototype.doAnyEmojisExist = function(): boolean {
  const regexPattern = emojiRegex();
  const regex = new RegExp(regexPattern);
  return regex.test(this);
}

/**
* Transforms a URL encoded string to its correct text representation
*/
String.prototype.formatVerificationCodeFromUrl = function(): string {
  // This is incredibly important to extrapolate the code from the URI formatting scheme.
  return String(this).split(' ').join('+');
}

// Important: Must import the file into main.ts
export {};